import { render, staticRenderFns } from "./EYArticle.vue?vue&type=template&id=171e29d6&scoped=true&"
import script from "./EYArticle.vue?vue&type=script&lang=js&"
export * from "./EYArticle.vue?vue&type=script&lang=js&"
import style0 from "./EYArticle.vue?vue&type=style&index=0&id=171e29d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171e29d6",
  null
  
)

export default component.exports